/**
 * @generated SignedSource<<bb31486dd8bc61b2153ff1366bd3a030>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SessionType = "UNMIND_MEET" | "ZOOM" | "GOOGLE" | "FRANKIE" | "%future added value";
export type CreateEventWithClientsInput = {
  event: CreateEventEventInput;
  sessionType?: SessionType | null;
  clients?: ReadonlyArray<CreateEventClientInput | null> | null;
  sendInvitationEmail: boolean;
  sendInvitationEmailComment?: string | null;
};
export type CreateEventEventInput = {
  accountId: string;
  userId: string;
  name: string;
  beginsAt: any;
  endsAt: any;
  recurring: boolean;
  recurringBegin?: any | null;
  recurringEnd?: any | null;
  icalendar?: string | null;
  timeZone: string;
  type: string;
  status: string;
  createdBy?: string | null;
  source: string;
  eventRequestId?: string | null;
};
export type CreateEventClientInput = {
  contactId: string;
  service?: CreateEventClientServiceInput | null;
};
export type CreateEventClientServiceInput = {
  productId?: string | null;
  name: string;
  currencyCode: string;
  price: number;
  dueDate: any;
  invoiceId?: number | null;
  requestPaymentInMeet?: boolean | null;
  paymentAmount?: number | null;
};
export type eventCreateEventWithGuestsMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateEventWithClientsInput;
};
export type eventCreateEventWithGuestsMutation$data = {
  readonly createEventWithClients: {
    readonly event: {
      readonly __id: string;
      readonly " $fragmentSpreads": FragmentRefs<"eventFragment">;
    };
  };
};
export type eventCreateEventWithGuestsMutation = {
  variables: eventCreateEventWithGuestsMutation$variables;
  response: eventCreateEventWithGuestsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v23 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionResponse",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventCreateEventWithGuestsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventPayload",
        "kind": "LinkedField",
        "name": "createEventWithClients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "eventFragment"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventCreateEventWithGuestsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventPayload",
        "kind": "LinkedField",
        "name": "createEventWithClients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "beginsAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endsAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recurring",
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "comment",
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icalendar",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recurrenceID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "originalStartTime",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Session",
                "kind": "LinkedField",
                "name": "session",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "password",
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventGuest",
                "kind": "LinkedField",
                "name": "eventGuests",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assessmentStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "contact",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unmindUserId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SessionLimitPayload",
                        "kind": "LinkedField",
                        "name": "sessionLimits",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sessionLimitType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amountRemaining",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiryDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrder",
                    "kind": "LinkedField",
                    "name": "salesOrders",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v13/*: any*/),
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerEmail",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerFirstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerLastName",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "grandAmount",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventRecurringId",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Payment",
                        "kind": "LinkedField",
                        "name": "payment",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paidAt",
                            "storageKey": null
                          },
                          (v21/*: any*/),
                          (v17/*: any*/),
                          (v6/*: any*/),
                          (v12/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SalesOrderItem",
                        "kind": "LinkedField",
                        "name": "salesOrderItems",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quantity",
                            "storageKey": null
                          },
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "discount",
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v6/*: any*/),
                              (v4/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/),
                              (v22/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taxAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discountAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paymentTerms",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentIn",
                        "kind": "LinkedField",
                        "name": "paymentIns",
                        "plural": true,
                        "selections": [
                          (v21/*: any*/),
                          (v12/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "payerEmail",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrder",
                            "kind": "LinkedField",
                            "name": "salesOrder",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventGuestAssessmentResponses",
                    "kind": "LinkedField",
                    "name": "eventGuestAssessmentResponses",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventGuestAssessmentResponse",
                        "kind": "LinkedField",
                        "name": "GAD",
                        "plural": true,
                        "selections": (v23/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventGuestAssessmentResponse",
                        "kind": "LinkedField",
                        "name": "PHQ",
                        "plural": true,
                        "selections": (v23/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventGuestAssessmentResponse",
                        "kind": "LinkedField",
                        "name": "Workplace",
                        "plural": true,
                        "selections": (v23/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "submittedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "userProfile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v16/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countryId",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "photoUrls",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "languages",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "setupComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "googleCredentials",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gender",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ethnicity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v13/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "platformAccess",
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "createdByUserProfile",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zoomMeetingDetails",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleMeetDetails",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "event",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "Edge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aaeb53b025e3afbdcda4865e31c571d5",
    "id": null,
    "metadata": {},
    "name": "eventCreateEventWithGuestsMutation",
    "operationKind": "mutation",
    "text": "mutation eventCreateEventWithGuestsMutation(\n  $input: CreateEventWithClientsInput!\n) {\n  createEventWithClients(input: $input) {\n    event {\n      ...eventFragment\n      id\n    }\n  }\n}\n\nfragment accountBaseFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment contactBaseInlineFragment on Contact {\n  id\n  firstName\n  lastName\n  source\n  userId\n  unmindUserId\n  ...contactSessionLimitsRemainingInlineFragment\n}\n\nfragment contactSessionLimitsRemainingInlineFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n    expiryDate\n  }\n}\n\nfragment eventFragment on Event {\n  id\n  name\n  userId\n  accountId\n  description\n  location\n  beginsAt\n  endsAt\n  recurring\n  timeZone\n  type\n  source\n  createdBy\n  comment\n  status\n  icalendar\n  recurrenceID\n  originalStartTime\n  createdAt\n  session {\n    ...sessionFragment\n    ...sessionInlineFragment\n    id\n  }\n  eventGuests {\n    ...eventGuestInlineFragment\n    ...eventGuestFragment\n    id\n  }\n  userProfile {\n    ...userProfileBaseInlineFragment\n    ...userProfileNameInlineFragment\n    ...userProfileBaseFragment\n    ...userProfileNameFragment\n    account {\n      ...accountBaseFragment\n      id\n    }\n    id\n  }\n  createdByUserProfile {\n    ...userProfileNameInlineFragment\n    id\n  }\n  zoomMeetingDetails\n  sessionType\n  googleMeetDetails\n}\n\nfragment eventGuestAssessmentResponsesFragment on EventGuestAssessmentResponses {\n  GAD {\n    id\n    questionId\n    questionResponse\n  }\n  PHQ {\n    id\n    questionId\n    questionResponse\n  }\n  Workplace {\n    id\n    questionId\n    questionResponse\n  }\n  submittedAt\n}\n\nfragment eventGuestAssessmentResponsesInlineFragment on EventGuestAssessmentResponses {\n  GAD {\n    id\n    questionId\n    questionResponse\n  }\n  PHQ {\n    id\n    questionId\n    questionResponse\n  }\n  Workplace {\n    id\n    questionId\n    questionResponse\n  }\n  submittedAt\n}\n\nfragment eventGuestFragment on EventGuest {\n  id\n  status\n  assessmentStatus\n  contact {\n    id\n    accountId\n    firstName\n    lastName\n    email\n    source\n  }\n  salesOrders {\n    ...salesOrderFragment\n    id\n  }\n  eventGuestAssessmentResponses {\n    ...eventGuestAssessmentResponsesFragment\n  }\n}\n\nfragment eventGuestInlineFragment on EventGuest {\n  id\n  status\n  assessmentStatus\n  contact {\n    ...contactBaseInlineFragment\n    id\n  }\n  salesOrders {\n    ...salesOrderBaseInlineFragment\n    salesOrderItems {\n      ...salesOrderItemInlineFragment\n      id\n    }\n    id\n  }\n  eventGuestAssessmentResponses {\n    ...eventGuestAssessmentResponsesInlineFragment\n  }\n}\n\nfragment paymentBaseInlineFragment on Payment {\n  id\n  paidAt\n  amount\n  currencyCode\n  accountId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment productFragment on Product {\n  id\n  externalRef\n  accountId\n  name\n  description\n  type\n  price\n  currencyCode\n  meta\n  createdAt\n}\n\nfragment salesOrderAmountFragment on SalesOrder {\n  subAmount\n  taxAmount\n  totalAmount\n  discountAmount\n  grandAmount\n  currencyCode\n  paymentTerms\n}\n\nfragment salesOrderBaseFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment salesOrderBaseInlineFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  totalAmount\n  grandAmount\n  currencyCode\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n  payment {\n    ...paymentBaseInlineFragment\n    id\n  }\n}\n\nfragment salesOrderFragment on SalesOrder {\n  ...salesOrderBaseFragment\n  ...salesOrderAmountFragment\n  ...salesOrderPaymentsFragment\n  salesOrderItems {\n    ...salesOrderItemFragment\n    id\n  }\n}\n\nfragment salesOrderItemFragment on SalesOrderItem {\n  id\n  name\n  description\n  quantity\n  price\n  discount\n  currencyCode\n  meta\n  product {\n    ...productFragment\n    id\n  }\n}\n\nfragment salesOrderItemInlineFragment on SalesOrderItem {\n  id\n  name\n  description\n  quantity\n  price\n  discount\n  currencyCode\n  meta\n  product {\n    ...productFragment\n    id\n  }\n}\n\nfragment salesOrderPaymentsFragment on SalesOrder {\n  paymentIns {\n    amount\n    createdAt\n    currencyCode\n    payerEmail\n    externalRef\n    salesOrder {\n      id\n      externalRef\n    }\n    id\n  }\n}\n\nfragment sessionFragment on Session {\n  id\n  password\n  externalRef\n}\n\nfragment sessionInlineFragment on Session {\n  id\n  password\n  externalRef\n}\n\nfragment userProfileBaseFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n  phone\n  languages\n  setupComplete\n  googleCredentials\n  gender\n  ethnicity\n}\n\nfragment userProfileBaseInlineFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n}\n\nfragment userProfileNameFragment on UserProfile {\n  firstName\n  lastName\n}\n\nfragment userProfileNameInlineFragment on UserProfile {\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "fe6875a13d84f707746450ca328ee6de";

export default node;
